/**
 * BuildPilotIntelligenceBadge
 * ─────────────────────────────────────────────────────────────
 * Small "Powered by BuildPilot Intelligence" pill badge. Rendered
 * across matcher touchpoints so the trust signal that currently
 * only lives inside the MiniMatcher header propagates everywhere
 * a matcher CTA is shown.
 *
 * Two variants:
 *   `light` - for dark surfaces (hero heros, cta cards on dark bg)
 *   `dark`  - for light surfaces (matcher prompt card, shortlist row)
 */
import { Zap } from 'lucide-react';

const BuildPilotIntelligenceBadge = ({
  variant = 'dark',
  className = '',
  testId = 'buildpilot-intelligence-badge',
  compact = false,
}) => {
  const isLight = variant === 'light';
  const base =
    'inline-flex items-center gap-1.5 rounded-full font-medium tracking-wide';
  const sizing = compact
    ? 'text-[10.5px] uppercase px-2.5 py-1'
    : 'text-[11px] uppercase px-3 py-1.5';
  const scheme = isLight
    ? 'bg-white/10 text-white/85 ring-1 ring-white/15'
    : 'bg-[#f5f5f7] text-[#424245] ring-1 ring-[#e8e8ed]';
  return (
    <span className={`${base} ${sizing} ${scheme} ${className}`} data-testid={testId}>
      <Zap className="w-3 h-3" fill="currentColor" />
      <span>Powered by BuildPilot Intelligence</span>
    </span>
  );
};

export default BuildPilotIntelligenceBadge;
